import React, { useContext, useEffect, useRef } from 'react';
import './NavbarSm.css'
import Image from '../shared/Image';
import logo from './../../public/image/logo192.png'
import Select from 'react-select';
import { NavLink, useLocation } from 'react-router-dom';
import MainContext from '../../context/mainContext';
import Login from './Login/Login';
import SearchContext from '../../context/searchContext';

const NavbarSm = () => {

    const context = useContext(MainContext)
    const searchContext = useContext(SearchContext)
    const { pathname } = useLocation();
    const focusInputRef = useRef(null);
    const ref = useRef(null);

    useEffect(() => {
        window.addEventListener('touchstart', () => {
            if (focusInputRef.current) {
                focusInputRef.current = false;
                ref.current && ref.current.blur();
            }
        });
        return () => window.removeEventListener('touchstart', () => { });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        pathname !== '/search' && setTimeout(() => {
            searchContext.onChangeSearch('')
            ref.current && ref.current.blur()
        }, 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname])

    const getShoppingCartCount = () => {
        const { shoppingCart } = context;
        let count = 0;
        const quantity = ['گرم', 'کیلو گرم', 'تن', 'لیتر', 'متر']
        try {
            shoppingCart.forEach(item => {
                if(!quantity.includes(item.unit)){
                    count += item.count;
                }
                else{
                    count += 1;
                }
            });
        } catch (error) {

        }
        return count;
    }

    return (
        <div className='navbarSm'>
            <div>
                <Image
                    src={logo}
                    width={65}
                    height={65}
                />
            </div>
            <div className='search-bar col'>
                <Select
                    placeholder={
                        <div style={{}} className='d-flex h-100 w-100 align-items-center'>
                        <div style={{ marginLeft: '7px', display: 'inline-block', fontSize: ".9rem" }}>جستجو در محصولات</div>
                        <b className='text-danger'>آلماتک</b>
                        <div className='ms-auto'>
                            <i className='fa fa-search ' style={{ fontSize: '.9rem'}}></i>
                        </div>
                    </div>
                    }
                    onInputChange={(value) => {
                        if (!value && !focusInputRef.current) {
                            return
                        }
                        else {
                            focusInputRef.current = true;
                            return searchContext.onChangeSearch(value);
                        }
                    }}
                    inputValue={searchContext.searchInput}
                    onFocus={() => (focusInputRef.current = true)}
                    ref={ref}
                    isClearable={false}
                    isSearchable={true}
                    isMulti={false}
                    hideSelectedOptions={true}
                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                : "none",
                            borderColor: state.isFocused
                                ? "#fff2e6"
                                : "#dee2e6",
                            width: "100%",
                            minHeight: '50px',
                            borderRadius: '0.375rem'
                        }),
                        menuList: (baseStyles, state) => ({
                            ...baseStyles,
                            maxHeight: "120px",
                            textAlign: "right",
                        }),
                        menu: (baseStyles) => ({
                            ...baseStyles,
                            zIndex: '3',
                            display: 'none'
                        })
                    }}
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary25: "#ddd",
                            primary: "#0a58ca",
                        },
                    })}
                    isRtl={true}
                    noOptionsMessage={() => ""}

                />
            </div>
            <nav>
                <NavLink
                    to='/'
                    className={pathname === '/' ? 'activeItem' : 'text-secondary'}
                >
                    <div><i className='fs-5 fa fa-home'></i></div>
                    <div>صفحه اصلی</div>
                </NavLink>
                <NavLink
                    to='/categories'
                    className={pathname === '/categories' ? 'activeItem' : 'text-secondary'}
                >
                    <div><i className='fs-5 fa fa-th-large'></i></div>
                    <div>دسته بندی</div>
                </NavLink>
                <NavLink
                    to='/cart'
                    className={pathname === '/cart' ? 'activeItem' : `text-secondary ${getShoppingCartCount() > 0 ? 'flusher' : ''}`}
                >
                    <div>
                        <span
                            className=' badge text-bg-success'
                            style={{opacity: context.shoppingCart.length ? '1' : '0'}}
                        >
                            {getShoppingCartCount()}
                        </span>
                        <i className='fs-5 fa fa-shopping-cart'></i>
                    </div>
                    <div>سبد خرید</div>
                </NavLink>
                <NavLink
                    to={context.loggedIn ? '/account-menu' : '#'}
                    className={(pathname === '/account-menu' || pathname === '/userInfo' || pathname === '/orders') ? 'activeItem' : 'text-secondary'}
                    onClick={() => {
                        if (!context.loggedIn) {
                            context.showLogin();
                        }
                    }}
                >
                    <div><i className='fs-5 fa fa-user'></i></div>
                    <div>حساب شما</div>
                </NavLink>
                {
                    (!context.loggedIn && window.innerWidth < 992) &&
                    <Login
                        show={context.showLoginModal}
                        onCancel={context.hideLogin}
                    />
                }
                <NavLink
                    to='/contact'
                    className={pathname === '/contact' ? 'activeItem' : 'text-secondary'}
                >
                    <div><i className='fs-5 fa fa-phone'></i></div>
                    <div>تماس با ما</div>
                </NavLink>
            </nav>
        </div>
    );
}

export default NavbarSm;